export enum EdeliveryAddressContext {
  Personal = "personal",
  Jdg = "jdg",
  Krs = "krs",
}
